import { StyledSearchableDropdown } from '@cont/BookScholarshipSchool/styles';
import React from 'react';

const InputSearchAbleDropdown = ({
  options,
  selectedOption,
  onSelect,
  placeholder,
  isKeyboardOpen
}) => {
  const [selected, setSelected] = React.useState(selectedOption);
  const [hasConfirmedSelection, setHasConfirmedSelection] =
    React.useState(false);
  const [showDropdown, setShowDropdown] = React.useState(false);
  const dropdownRef = React.useRef(null);

  React.useEffect(() => {
    setSelected(selectedOption);
    const hasValue = !!(selectedOption?.value || selectedOption?.label);
    setHasConfirmedSelection(hasValue);
  }, [selectedOption]);

  React.useEffect(() => {
    if (isKeyboardOpen && showDropdown && dropdownRef.current) {
      setTimeout(() => {
        dropdownRef.current?.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }, 100);
    }
  }, [isKeyboardOpen, showDropdown]);
  const renderDropdownItem = (item) => (
    <div
      role="button"
      tabIndex={0}
      onClick={() => {
        setSelected(item);
        onSelect(item);
        setHasConfirmedSelection(true);
        setShowDropdown(false);
      }}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          setSelected(item);
          onSelect(item);
          setHasConfirmedSelection(true);
          setShowDropdown(false);
        }
      }}
      style={{
        cursor: 'pointer',
        padding: '8px 0',
        background: '-var(--color-base-1)'
      }}
    >
      {item.label}
    </div>
  );
  const handleValueChange = (searchText) => {
    setHasConfirmedSelection(false);

    if (searchText === '') {
      const emptyOption = { id: '', label: '', value: '' };
      setSelected(emptyOption);
      onSelect(emptyOption);
      setShowDropdown(true);
    } else {
      setShowDropdown(true);
    }
  };

  const handleToggleSearchDropdown = (isOpen) => {
    setShowDropdown(isOpen);
  };
  return (
    <div ref={dropdownRef}>
      <StyledSearchableDropdown
        isOpen={showDropdown}
        placeholder={placeholder}
        options={options}
        shouldHandleClickAwayManually
        selectedOption={selected}
        labelKey="label"
        dropdownItem={renderDropdownItem}
        wrapperStyle
        clearOnAway={!isKeyboardOpen}
        crossIcon={hasConfirmedSelection}
        onlySearchbar={hasConfirmedSelection}
        onValueChange={handleValueChange}
        toggleSearchDropdown={handleToggleSearchDropdown}
      />
    </div>
  );
};
export default InputSearchAbleDropdown;
